import styled from 'styled-components';

import svgBackgroundBanner from '@assets/svg/background-banner.svg';

export default styled.div`
  position: relative;
  width: 100%;
  min-height: 200px;
  background-image: url(${svgBackgroundBanner});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 32px;
  border-radius: 10px;
  margin-bottom: 24px;
  margin-top: 0px;
  box-shadow: ${({ theme }) => theme.shadows.low};

  > img {
    position: absolute;
    top: 24px;
    right: 24px;
  }

  span {
    color: #fff;
    display: block;

    &.banner-heading {
      font-size: 24px;
      letter-spacing: 0;
      line-height: 32px;
    }

    &.banner-subheading {
      margin-top: 12px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 20px;
      max-width: 520px;
    }
  }

  button {
    width: 160px;
    height: 30px;
    margin-top: 16px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.1);
    border-width: 0;
    color: #fff;
    cursor: pointer;
  }
`;
